const getUrl = (skipLogic, store) => {
    const {survey} = store
    let url = "/api/survey/" + survey.id + "/skiplogic"
    if (skipLogic.id) {
        url += "/" + skipLogic.id
    }
    return url
}

const created = async (response, skipLogic, store) => {
    skipLogic.id = response[response.length - 1].id
    store.survey.skipLogic.push(skipLogic)
    return response
}

const saved = async (response, store) => {
    const msg = 'Skiplogic updated'
    store.survey.refreshSkipLogic(store, true)
    store.addNotification(null, msg, 'success')
    return response
}

const move = async (response, skipLogic, store) => {
    const {survey} = store
    survey.skipLogic.splice(survey.skipLogic.findIndex(sl => sl === skipLogic.id), 1, skipLogic)
    return response
}

const removed = async (response, skipLogic, store) => {
    const {survey} = store
    const index = survey.skipLogic.findIndex(sl => sl.id === skipLogic.id)
    if (index > -1) {
        survey.skipLogic.splice(index, 1)
    }
    return response
}

const failed = (error, store) => {
    console.log(error)
    store.survey.refreshSkipLogic(store, true)
    store.addNotification(null, "Error updating skiplogic: " + error.message, "error")
}

const save = async (skipLogic, store) => {
    const json = JSON.stringify({
        data: skipLogic.toJSON(),
    })
    await store.http.post(getUrl(skipLogic, store), json, store.surveyToken)
        .then((res) => created(res, skipLogic, store))
        .then((res) => saved(res, store))
        .catch((error) => failed(error, store))
}

const update = async (skipLogic, store) => {
    const json = JSON.stringify({
        data: skipLogic.toJSON(),
    })
    await store.http.put(getUrl(skipLogic, store), json, store.surveyToken)
        .then((res) => move(res, skipLogic, store))
        .then((res) => saved(res, store))
        .catch((error) => failed(error, store))
}

const remove = async (skipLogic, store) => {
    await store.http.delete(getUrl(skipLogic, store), store.surveyToken)
        .then((res) => removed(res, skipLogic, store))
        .then((res) => saved(res, store))
        .catch((error) => failed(error, store))
}

export default {
    save,
    update,
    remove,
}
